<template>
    <main>
        <Head>
            <title>{{ page.meta_title }}</title>
            <meta name="description" :content="page.meta_description" inertia="description" />
        </Head>

         <Header :image="page.headerImage" title="Vacatures" />

        <div class="bg-white w-full">
            <div class="max-w-(--breakpoint-2xl) container mx-auto px-6 lg:px-8 pt-4 pb-8">
                <Breadcrumbs/>
                          <div class="mt-8">
                    <button @click="showModal" class="button dgreen">Solliciteer nu!</button>
                </div>

                <!-- Content -->
                <div class="py-6 leading-7 d-prose max-w-none prose-h2:text-xl">
                    <div v-html="page.body"></div>
                </div>

                <div class="mb-8">
                    <button @click="showModal" class="button dgreen">Solliciteer nu!</button>
                </div>

                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 md:col-span-8 h-148 gap-4">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-4 md:col-span-4">
                                <img
                                    class="rounded-lg object-cover h-full w-full"
                                    :src="asset('img/over-ons/pand-voorkant.jpeg')"
                                    alt="Pand Doorax"
                                />
                            </div>
                            <div class="col-span-4 md:col-span-4">
                                <img
                                    class="rounded-lg object-cover h-full w-full"
                                    :src="asset('img/over-ons/menno-kantoor.jpeg')"
                                    alt="Kantoor"
                                />
                            </div>
                            <div class="col-span-4 md:col-span-4">
                                <img
                                    class="rounded-lg object-cover h-full w-full"
                                    :src="asset('img/over-ons/kantine2.jpeg')"
                                    alt="Kantine"
                                />
                            </div>
                        </div>

                        <div class="col-span-2 md:col-span-2 mt-4">
                            <div class="grid gap-4 h-full">
                                <img
                                    class="rounded-lg object-cover h-full w-full"
                                    :src="asset('img/over-ons/kantoor.jpeg')"
                                    alt="Kantoor"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-span-12 md:col-span-4">
                        <img
                            class="rounded-lg object-cover h-full w-full"
                            :src="asset('img/over-ons/menno-jorn-beneden.jpeg')"
                            alt="Vergadering"
                        />
                    </div>
                </div>

                <div class="grid grid-cols-12 gap-4 mt-4 h-148">
                    <div class="col-span-6 md:col-span-6 gap-4">
                        <img
                            class="rounded-lg object-cover h-full w-full"
                            :src="asset('img/over-ons/hung-werkplaats.jpeg')"
                            alt="Werkplaats"
                        />
                    </div>

                    <div class="col-span-6 md:col-span-3 gap-4">
                        <img
                            class="rounded-lg object-cover h-full w-full"
                            :src="asset('img/over-ons/magazijn2.jpeg')"
                            alt="Magazijn"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-3 gap-4">
                        <div class="grid gap-4 h-full">
                            <img
                                class="rounded-lg object-cover h-full w-full"
                                :src="asset('img/over-ons/magazijn1.jpeg')"
                                alt="Magazijn"
                            />
                            <img
                                class="rounded-lg object-cover h-full w-full"
                                :src="asset('img/over-ons/hung-werkplaats-sleutelmachine.jpeg')"
                                alt="Werkplaats"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <teleport to="#modals">
            <modal title="" ref="modalref">
                <strong>Sollicitatieformulier</strong>
                <template v-slot:content>
                    <JobRequest @close="hideModal" />
                </template>
            </modal>
        </teleport>
        <!-- <ServiceFooter  /> -->
    </main>
</template>

<script setup>
import JobRequest from '@/Components/JobRequest.vue';
import Header from '@/Components/Post/Header.vue';
import { ref } from 'vue';

const inBrowser = typeof window !== 'undefined';

const modalref = ref(false);

const props = defineProps({
    page: Object,
});

function hideModal() {
    modalref.value.open = false;
}
function showModal() {
    modalref.value.open = true;
}
</script>
